export const availableDeviceModels = {
  circuits: {
    NVent910: 'NVent 910',
    NVent920: 'Nvent 920',
    NVentNGC30: 'NVent NGC30',
    NVentNGC40: 'NVent NGC40',
    NVentCM2000P: 'NVent AC2000+',
    ThermonTCM2: 'Thermon TCM2',
    ThermonTCM18: 'Thermon TCM18',
    ThermonTC101: 'Thermon TC101',
    ThermonTC201: 'Thermon TC201',
    ThermonTC202: 'Thermon TC202',
    ThermonTC1818: 'Thermon TC1818',
    ThermonGenesis: 'Thermon Genesis',
    MasterTraceMR100: 'MasterTrace MR100',
    SmartTraceMP: 'SmartTrace Monitored Panel',
    ChromaloxITLSC1D2EXT: 'Chromalox ITLSC1D2',
  },
  controllers: {
    NVentNGC30Controller: 'NVent NGC30 Controller',
    NVentNGC40Controller: 'NVent NGC40 Controller',
    NVentCM2000PController: 'NVent AC2000+ Controller',
    ThermonTCM2Controller: 'Thermon TCM2 Controller',
    ThermonTCM18Controller: 'Thermon TCM18 Controller',
    ThermonTC101Controller: 'Thermon TC101 Controller',
    ThermonTC201Controller: 'Thermon TC201 Controller',
    ThermonTC202Controller: 'Thermon TC202 Controller',
    ThermonTC1818Controller: 'Thermon TC1818 Controller',
    ThermonGenesisController: 'Thermon Genesis Controller',
    MasterTraceMR100Controller: 'MasterTrace MR100 Controller',
    SmartTraceMPController: 'SmartTrace Monitored Panel',
    ChromaloxITLSC1D2EXTControllerDevice: 'Chromalox ITLSC1D2 Controller',
  }
} as const;

// Type helpers
export type CircuitModel = keyof typeof availableDeviceModels.circuits;
export type ControllerModel = keyof typeof availableDeviceModels.controllers;
export type DeviceModel = CircuitModel | ControllerModel;
